__webpack_require__.p = "/seniorCitizenBanking/awareness/";